module.exports = "/fonts/nucleo-icons.eot?541f8898b990ff0172689d23e73dc0ee";